module.exports = __webpack_public_path__ + "img/img27.4c50df4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/02/img27.png
// module id = 204
// module chunks = 0